import React from 'react'

import POEntityDetailPage from '@/components/views/ci/PO/POEntityDetailPage'

const PO_ISEntityDetailPage = () => {
    return <POEntityDetailPage />
}

export default PO_ISEntityDetailPage
